// This file was automatically generated from appanalytics.dialog.viewBulkLetterPatients.html.
// Please don't edit this file by hand.

goog.provide('el8.template.appanalytics.dialog.viewBulkLetterPatients');

goog.require('soy');
goog.require('soy.StringBuilder');
goog.require('el8.template.appanalytics.reports.muPopulation');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appanalytics.dialog.viewBulkLetterPatients.container = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="overlayContainer"></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appanalytics.dialog.viewBulkLetterPatients.content = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<h3 class="el8AppColor">', soy.$$escapeHtml(opt_data.header), '</h3><p class="el8Spacer el8AppColor">', soy.$$escapeHtml(opt_data.description), '</p>', (opt_data.numTabs > 1) ? '<div class="tabbed-nav el8TabHomeSection"></div>' : '', '<div class="el8Spacer">');
  if (opt_data.numTabs > 1) {
    var iLimit44 = opt_data.numTabs;
    for (var i44 = 0; i44 < iLimit44; i44++) {
      output.append('<div class="patient-list-tab-', soy.$$escapeHtml(i44), ' el8OverflowAuto" style="margin: 0 auto;"></div>');
    }
  } else {
    output.append('<div class="patient-list el8OverflowAuto" style="margin: 0 auto;"></div>');
  }
  output.append('</div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appanalytics.dialog.viewBulkLetterPatients.list = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (opt_data.patientList.length) {
    output.append('<table class="practiceReportTable">');
    el8.template.appanalytics.dialog.viewBulkLetterPatients.showPatients({patientList: opt_data.patientList}, output);
    output.append('</table>');
  } else {
    output.append('<p class="el8FeedEmpty">No entries found</p>');
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appanalytics.dialog.viewBulkLetterPatients.showPatients = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<thead><tr><th class="el8Bold">Patient Name</th><th class="el8Bold">D.O.B.</th><th class="el8Bold">Phone</th><th class="el8Bold">Last Visit</th><th class="el8Bold">Next Visit</th></tr></thead><tbody>');
  var pList62 = opt_data.patientList;
  var pListLen62 = pList62.length;
  for (var pIndex62 = 0; pIndex62 < pListLen62; pIndex62++) {
    var pData62 = pList62[pIndex62];
    output.append('<tr><tr><td class="reportIndicatorName">');
    el8.template.appanalytics.reports.muPopulation.passportStatusIcon({status: pData62.passport_status_s}, output);
    output.append('&nbsp;', (pData62['vip']) ? '<span class="el8VipTag">VIP</span>&nbsp;<a target="_blank" rel="noopener" href="/patient/' + soy.$$escapeHtml(pData62['id']) + '/">' + soy.$$escapeHtml(pData62['id']) + '</a>' : '<a target="_blank" rel="noopener" href="/patient/' + soy.$$escapeHtml(pData62['id']) + '/">' + soy.$$escapeHtml(pData62['name']) + '</a>', '</td><td>', (pData62['dob']) ? soy.$$escapeHtml(pData62['dob']) : '', '</td><td>', (pData62['phone']) ? soy.$$escapeHtml(pData62['phone']) : '', '</td><td>', (pData62['last_seen_date_dt']) ? (soy.$$escapeHtml(pData62['last_seen_date_dt'])? el8.service.tz.soyDateTime(soy.$$escapeHtml(pData62['last_seen_date_dt'])) : '') : '', '</td><td>', (pData62['next_appt_dt']) ? (soy.$$escapeHtml(pData62['next_appt_dt'])? el8.service.tz.soyDateTime(soy.$$escapeHtml(pData62['next_appt_dt'])) : '') : '', '</td></tr></tr>');
  }
  output.append('</tbody>');
  if (!opt_sb) return output.toString();
};
